import React from 'react';
import Icon from '../../Icon/index.js';
import { IconButton } from './style.js';

var DeleteIcon = function () { return (React.createElement(Icon.XShape, { styleType: "delete", color: "#868E96" })); };
var CheckIcon = function () { return React.createElement(Icon.State, { styleType: "check", size: "small" }); };
var VisibilityOnIcon = function () { return (React.createElement(Icon.Functional, { styleType: "visibility-on", color: "#868E96" })); };
var VisibilityOffIcon = function () { return (React.createElement(Icon.Functional, { styleType: "visibility-off", color: "#868E96" })); };
function ResetIconButton(_a) {
    var right = _a.right, onClick = _a.onClick;
    return (React.createElement(IconButton, { right: right, onClick: onClick, type: "button", tabIndex: -1 },
        React.createElement(DeleteIcon, null)));
}
function VisibilityIconButton(_a) {
    var type = _a.type, right = _a.right, onClick = _a.onClick;
    return (React.createElement(IconButton, { right: right, onClick: onClick, type: "button", tabIndex: -1 }, type === 'password' ? React.createElement(VisibilityOnIcon, null) : React.createElement(VisibilityOffIcon, null)));
}

export { CheckIcon, DeleteIcon, ResetIconButton, VisibilityIconButton, VisibilityOffIcon, VisibilityOnIcon };
